module.exports = __webpack_public_path__ + "cfdd9e342737149545d6b20bf00364b1.fbx";